import { err, ok, Result } from '@easeltv/fail';

/**
 * parseJSON
 *
 * Parse the value pulled from local storage into json
 *
 * @param value - Local storage value
 */
export const parseJSON = <T>(
    value: string | undefined,
): Result<T | undefined> => {
    try {
        if (typeof value === 'undefined') return ok(undefined);

        return ok(JSON.parse(value));
    } catch (error) {
        return err({
            userMessage: 'Failed to parse JSON',
            key: 'json.parse.error',
            data: error,
        });
    }
};
